import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { EditOutlined } from "@mui/icons-material";

import {
  ContractorDetailContext,
  useContractorDetailContext,
} from "contexts/ContractorDetailContext";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import ContractorBasicDetail from "./contractorComponents/ContractorBasicDetail";
import EnableDisableButton from "components/Shared/EnableDisableButton";

import {
  useGetContractorDetailQuery,
  useUpdateContractorMutation,
} from "store/services/contractorApi";

import { useAppMeta } from "hooks";
import ContractorDetailTab from "./contractorComponents/ContractorDetailTab";

const ContractorDetailScreen = () => {
  const { id } = useParams();

  const breadcrumbs = [
    { title: "Contractor Profile", path: "/app/crm/contractor/list" },
    { title: "Contractor Profile Detail" },
  ];

  // RTK Query
  const {
    data: contractorDetail,
    isLoading: loadingContractor,
    error,
  } = useGetContractorDetailQuery(id);

  useAppMeta("Contractor Detail");

  return (
    <ContractorDetailContext.Provider value={{ contractorDetail, loadingContractor }}>
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingContractor}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />

        <BreadcrumbLayout.Paper>
          <ContractorBasicDetail />
          <ContractorDetailTab />
        </BreadcrumbLayout.Paper>
        
      </BreadcrumbLayout>
    </ContractorDetailContext.Provider>
  );
};

export default ContractorDetailScreen;

const PageActions = () => {
  const { contractorDetail, loadingContractor } = useContractorDetailContext();

  // RTK Query
  const [updateContractor, { isLoading: updatingContractor }] =
    useUpdateContractorMutation();

  // methods
  const handleToggleContractorStatus = async () => {
    try {
      await updateContractor({
        _id: contractorDetail?._id,
        isActive: !contractorDetail?.isActive,
      }).unwrap();
      toast.info(
        `Contractor successfully ${
          contractorDetail?.isActive ? "Disabled" : "Enabled"
        }!`
      );
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update Contractor Status!");
    }
  };

  return (
    <div className="flex items-center gap-4">
      {false && (
        <EnableDisableButton
          isActive={contractorDetail?.isActive}
          loading={loadingContractor || updatingContractor}
          onClick={handleToggleContractorStatus}
        />
      )}

      <Link to={`/app/crm/contractor/${contractorDetail?._id}/edit`}>
      
        <Button startIcon={<EditOutlined />} variant="contained">
          Edit
        </Button>
      </Link>
    </div>
  );
};
